/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseTollTransaction } from '../../models/response-toll-transaction';

export interface GetTransactions$Params {

/**
 * customer GUID from svgzapi-core
 */
  customerGUID: string;
  limit?: number;
  offset?: number;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';

/**
 * a list of providers
 */
  providers?: Array<string>;

/**
 * the settlement flag. if true the service will return settled transactions otherwise unsettled
 */
  settled: boolean;
  id?: string;
  customerBaseId?: string;
  provider?: string;
  licensePlate?: string;
  country?: string;
  servicePointName?: string;
  servicePointMake?: string;
  mileage?: string;
  serviceCardNumber?: string;
  transactionDate?: string;
  transactionTime?: string;
  settlementDate?: string;
  material?: string;
  totalNetAmount?: string;
  totalGrossAmount?: string;
  vatRate?: string;
  invoiceNumber?: string;
  vatAmount?: string;
}

export function getTransactions(http: HttpClient, rootUrl: string, params: GetTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseTollTransaction>> {
  const rb = new RequestBuilder(rootUrl, getTransactions.PATH, 'get');
  if (params) {
    rb.query('customerGUID', params.customerGUID, {});
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('sortOrder', params.sortOrder, {});
    rb.query('providers', params.providers, {});
    rb.query('settled', params.settled, {});
    rb.query('id', params.id, {});
    rb.query('customerBaseId', params.customerBaseId, {});
    rb.query('provider', params.provider, {});
    rb.query('licensePlate', params.licensePlate, {});
    rb.query('country', params.country, {});
    rb.query('servicePointName', params.servicePointName, {});
    rb.query('servicePointMake', params.servicePointMake, {});
    rb.query('mileage', params.mileage, {});
    rb.query('serviceCardNumber', params.serviceCardNumber, {});
    rb.query('transactionDate', params.transactionDate, {});
    rb.query('transactionTime', params.transactionTime, {});
    rb.query('settlementDate', params.settlementDate, {});
    rb.query('material', params.material, {});
    rb.query('totalNetAmount', params.totalNetAmount, {});
    rb.query('totalGrossAmount', params.totalGrossAmount, {});
    rb.query('vatRate', params.vatRate, {});
    rb.query('invoiceNumber', params.invoiceNumber, {});
    rb.query('vatAmount', params.vatAmount, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseTollTransaction>;
    })
  );
}

getTransactions.PATH = '/transactions';
